export enum SearchFormSizes {
    Small = "-small",
    Large = "",
}
